export class MoreLink {
	private iab = false;

	public text		= '';
	public url		= '';

	constructor(data: any, image?: string, text?: string, url?: string) {
		if (typeof data === 'object') {
			this.iab		= typeof data.iab		=== 'boolean'	? data.iab		: this.iab;
			this.text		= typeof data.text	=== 'string'	? data.text		: this.text;
			this.url		= typeof data.url		=== 'string'	? data.url		: this.url;
		} else if (typeof data === 'boolean') {
			this.iab		= typeof data		=== 'boolean'	? data	: this.iab;
			this.text		= typeof text		=== 'string'	? text	: this.text;
			this.url		= typeof url		=== 'string'	? url		: this.url;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/ui/moreLink.ts